import { render, staticRenderFns } from "./ORM.vue?vue&type=template&id=26b82858&scoped=true&"
import script from "./ORM.vue?vue&type=script&lang=js&"
export * from "./ORM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b82858",
  null
  
)

export default component.exports